export const SURPRISE_BOX_ERROR_MESSAGES = {
  surprise_box_promotion_immutable:
    'This promotion is finalised and cannot be edited.',
  surprise_box_prize_locked:
    'Prize value cannot be changed after tickets have been sold.',
  surprise_box_ticket_price_locked:
    'Ticket price cannot be changed after tickets have been sold.',
  surprise_box_start_time_locked_active:
    'Start time cannot be changed once the promotion is active.',
  surprise_box_sales_close_extend_only:
    'Sales close time can only be extended, not shortened.',
  surprise_box_draw_time_extend_only:
    'Draw time can only be extended once tickets are sold.',
  surprise_box_sales_close_before_start:
    'Sales close must be after the start time.',
  surprise_box_sales_close_after_draw:
    'Sales close must be on or before the draw time.',
  surprise_box_times_required: 'All time fields are required.',
  surprise_box_start_time_in_future:
    'Start time must be now or earlier to activate.',
  surprise_box_sales_window_closed: 'Sales window has already closed.',
  surprise_box_draw_time_in_past: 'Draw time must be in the future.',
  surprise_box_not_draft: 'Only draft promotions can be activated.',
  surprise_box_active_conflict: 'Another promotion is already active.',
  surprise_box_not_active: 'Only active promotions can be deactivated.',
  surprise_box_deactivate_with_tickets:
    'Cannot deactivate after tickets have been sold.',
  surprise_box_already_terminal:
    'This promotion is already in a terminal state.',
  surprise_box_cancel_needs_refund:
    'Cannot cancel after tickets are sold (refund flow unavailable).',
}

export const annotateSurpriseBoxError = (error) => {
  const data = error?.response?.data
  if (!data) return error
  const friendly = SURPRISE_BOX_ERROR_MESSAGES[data.code]
  if (friendly && !data.error) {
    data.error = friendly
  }
  return error
}
